import { makeStyles } from 'tss-react/mui';

// TODO jss-to-tss-react codemod: usages of this hook outside of this file will not be converted.
export const useDeleteModalStyles = makeStyles({ name: 'DeleteModal' })(theme => ({
  deleteButton: {
    background: theme.palette.error.main,
    color: theme.palette.error.contrastText,
    '&:hover': {
      background: theme.palette.error.dark,
    }
  },
  deleteModalActions: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
  },
  paperWidthXs: {
    maxWidth: '343px',
  },
  textAlignCenter: {
    textAlign: 'center',
  },
}));
